var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/modules/_html.js
// module id = 561
// module chunks = 0